webpackJsonp(["quote-cta"],{

/***/ "/tool/node_modules/babel-loader/lib/index.js??ref--15-0!/tool/node_modules/eslint-loader/index.js!/tool/project/client/src/core/components/epi-blocks/quote-cta/quote-cta.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__("external \"jQuery\"");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// import debug from 'debug';

var QuoteCtaController = function () {
	function QuoteCtaController(element, options) {
		_classCallCheck(this, QuoteCtaController);

		this.options = options;
		this.element = element;
		this.$element = (0, _jquery2.default)(element);

		this.submitButtons = [].concat(_toConsumableArray(this.element.querySelectorAll(this.options.submitButtonSelector)));
		this.collapsibles = [].concat(_toConsumableArray(this.element.querySelectorAll(this.options.collapsiblesSelector)));

		this.watch();
	}

	_createClass(QuoteCtaController, [{
		key: 'watch',
		value: function watch() {
			var _this = this;

			this.$element.on('closeothers', this.closeOtherCollapsibles.bind(this));

			this.submitButtons.forEach(function (button) {
				button.addEventListener('click', _this.setAction.bind(_this));
			});
		}
	}, {
		key: 'setAction',
		value: function setAction(event) {
			var button = event.currentTarget;
			var url = button.dataset.action;
			if (url) {
				this.element.action = url;
			}
		}
	}, {
		key: 'closeOtherCollapsibles',
		value: function closeOtherCollapsibles(event) {
			var opening = event.target;
			var toClose = this.collapsibles.filter(function (item) {
				return item !== opening;
			});

			toClose.forEach(function (item) {
				item.dataset.collapsibleOpen = false;
			});
		}
	}]);

	return QuoteCtaController;
}();

QuoteCtaController.DEFAULTS = {};

exports.default = QuoteCtaController;

/***/ })

});


// WEBPACK FOOTER //
// scripts/quote-cta--b160237bb6791a377fe0.js